// Playback preserves the supplied transcript. Only the timing is compressed.
export function conversationTimeline(exchanges) {
  let at = 0;
  return exchanges.map(exchange => {
    const prompt = at;
    const commentary = prompt + 650;
    const activities = exchange.activities.map((_, index) => commentary + 750 + index * 420);
    const answer = (activities.at(-1) || commentary) + 850;
    const blocks = exchange.blocks.map((_, index) => answer + index * 850);
    at = (blocks.at(-1) || answer) + 3400;
    return { prompt, commentary, activities, answer, blocks, end: at };
  });
}
